import { render, staticRenderFns } from "./StoryWebtoon.vue?vue&type=template&id=4f27db70&scoped=true"
import script from "./StoryWebtoon.vue?vue&type=script&lang=js"
export * from "./StoryWebtoon.vue?vue&type=script&lang=js"
import style0 from "./StoryWebtoon.vue?vue&type=style&index=0&id=4f27db70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f27db70",
  null
  
)

export default component.exports